import { isToBApp, appVersion } from 'base/config'
function toNum(str) {
  let a = str.toString()
  let c = a.split('.')
  let num_place = ['', '0', '00', '000', '0000'],
    r = [...num_place].reverse()
  for (var i = 0; i < c.length; i++) {
    var len = c[i].length
    c[i] = r[len] + c[i]
  }
  return c.join('')
}
// 版本比较
function compareVersion(a, b) {
  var _a = toNum(a),
    _b = toNum(b)
  if (_a == _b) return 0
  if (_a > _b) return 1
  if (_a < _b) return -1
}
const ua = navigator.userAgent.toLowerCase()
// android version
let androidVersion = ua.match(/android (.*?);/)
if (androidVersion && androidVersion[1]) {
  androidVersion = androidVersion[1].split('.')[0]
}
// ios version
let iosVersion = ua.match(/cpu iphone os (.*?) like mac os/)
if (iosVersion && iosVersion[1] && iosVersion[1].split('_')) {
  iosVersion = iosVersion[1].split('_')[0]
}
// (1) android >= 6.0
const isMatchAndroid = androidVersion >= 6
// (2) ios && app != 7.0.0 && app != 7.1.0 && (app >= 7.2.0 && ios >= 11 || app < 7.2.0 && ios < 14)
const isApp7_0and7_1 = compareVersion(appVersion, '7.0.0') == 0 || compareVersion(appVersion, '7.1.0') == 0
const isApp7_2 = compareVersion(appVersion, '7.2.0') >= 0
const isMatchIosWidthApp = !isApp7_0and7_1 && ((isApp7_2 && iosVersion >= 11) || (!isApp7_2 && iosVersion < 14))

export default {
  data() {
    return {
      // 录屏
      // app 支持录屏功能
      // Android 见 (1)
      // IOS 见 (2)
      isSupportRecordScreen:
        appBridge &&
        appBridge.checkAppFeature('SHOW_SCREEN_RECORDER') &&
        ((appBridge.isAndroid() && isMatchAndroid) ||
          isMatchIosWidthApp)
    }
  },
  computed: {
    isSchemeShowByApp() {
      return (isToBApp && this.isSupportRecordScreen) || !isToBApp
    }
  }
}
